import projectService from '../../services/project';
import templateService from '../../services/template';
import Vue from 'vue';
// import Vue from 'vue'

const state = {
    error: false,
    loading: false,
    project: {
        id: 0,
        // Project data
        hash: '',
        email: '',
        user_name: '',
        orderId: '',
        source: '',

        // Draft data
        name: '',
        code: '',

        // Common data
        scenes: [],
    },
    previewGuestIndex: null,
    activeScene: null,
    activeVersion: null,
    preview: false,
}

const getters = {
    error: (state) => state.error,
    loading: (state) => state.loading,
    project: (state) => state.project,
    activeScene: (state) => state.activeScene,
    activeVersion: (state) => state.activeVersion,
    scene: (state) => state.project.scenes.length && state.project.scenes[state.activeScene],
    version: (state, getters) => getters.scene && getters.scene.versions[state.activeVersion],
    previewGuestIndex: (state) => state.previewGuestIndex,
    previewGuest: (state, getters) => getters.scene && getters.scene.guests[state.previewGuestIndex],
    isPreview: (getters) => getters.preview,
    isBlocked: (state, getters, rootState, rootGetters) => {
        if (rootGetters['user/loggedIn']) {
            return false
        }

        return getters.project && getters.project.status && ['project_closed', 'project_approved'].includes(getters.project.status.code)
    },
}

const actions = {
    getDraft({ commit, dispatch }, templateCode) {
        commit('setLoading');

        return templateService.getOneByCode(templateCode)
            .then((draft) => {
                commit('setLoading', false);
                commit('setProject', draft);
                dispatch('setActiveSceneVersion', { scene: 0, version: 0 });

                return draft
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    getProject({ commit, dispatch }, projectId) {
        commit('setLoading');

        return projectService.getOneByHash(projectId)
        
            .then((project) => {
                commit('setLoading', false);
                commit('setProject', project);
                dispatch('setActiveSceneVersion', { scene: 0, version: 0 });

                return project
            })
            .catch((error) => {
                commit('setLoading', false);
                commit('setError', error);
            })
    },
    updateDraft({ commit, getters }) {
        commit('setLoading');
        console.log(JSON.stringify(getters.project.scenes))
        try {
            const data = templateService.updateDraft(getters.project.scenes)
            
            return data

        } catch (error) {
            commit('setError', error);
        } finally {
            commit('setLoading', false);
        }
    },
    async saveProject({ commit, getters }, saveData) {
        commit('setLoading');

        try {

            const result = getters.project.hash ? await projectService.updateProject(getters.project) : await projectService.createProject(getters.project, saveData)

            if (result) {
                commit('updateProject', result);
            }

            return result

        } catch (error) {
            commit('setError', error);
        } finally {
            commit('setLoading', false);
        }
    },
    async setStatus({ commit, getters }, status) {
        commit('setLoading');

        try {

            const result = await projectService.setStatus(getters.project, status)

            if (result) {
                commit('updateProject', result);
            }

            return result

        } catch (error) {
            commit('setError', error);
        } finally {
            commit('setLoading', false);
        }
    },
    setActiveSceneVersion({ commit }, params) {
        commit('setActiveSceneVersion', params)
    },
    newSceneVersion({ commit, dispatch, getters }, scene) {
        commit('newSceneVersion', scene)

        const newSceneIndex = getters.project.scenes.length - 1

        dispatch('setSceneGuests', { scene: newSceneIndex, guests: [] })
        dispatch('setActiveSceneVersion', { scene: newSceneIndex, version: 0 })
    },
    removeScene({ commit }, index) {
        commit('removeScene', index)
    },
    newScene({ commit, dispatch, state }, scene) {
        commit('newScene', scene)
        console.log(scene);

        dispatch('setActiveSceneVersion', { 
            scene: state.project.scenes.length - 1,
            version: 0
        })
    },
    setNote({ commit }, data) {
        commit('setNote', data)
    },
    setScene({ commit, getters }, scene) {
        commit('setScene', { scene, activeScene: getters.activeScene })
    },
    setSceneGuests({ commit }, data) {
        commit('setSceneGuests', data)
    },
    removeSceneGuest({ commit }, data) {
        commit('removeSceneGuest', data)
    },
    setPreviewGuest({ commit }, guest) {
        commit('setPreviewGuest', guest)
    },
    setPreview({ commit }, status) {
        commit('setPreview', status)
    },
    setPreviewGuestIndex({ commit, dispatch, getters }, guestIndex) {

        if (!getters.isPreview) {
            dispatch('setActiveSceneVersion', {
                scene: getters.activeScene,
                version: getters.scene.versions.findIndex((version) => version.attributes.personalizedField === '1'),
            });
        }

        commit('setPreviewGuestIndex', guestIndex)
        commit('setPreview', guestIndex !== null)
    },
    setGuestPosition({ commit, getters }, cords) {
        if (getters.previewGuestIndex !== null) {
            commit('setPreviewGuest', cords)
        }
    },
    setSceneName({ commit }, data) {
        commit('setSceneName', data)
    },
    setActiveInvitationContent({ commit, getters }, content) {
        console.log('setActiveInvitationCOntent is preveiw', getters.isPreview)
        if (getters.isPreview) {
            return
        }
        
        console.log('set setActiveInvitationContent ')
        commit('setActiveInvitationContent', content)
    },
}

const mutations = {
    setNote(state, data) {
        Vue.set(state.project.scenes[data.scene], 'note', data.note)
    },
    setActiveSceneVersion(state, { scene, version }) {
        state.activeScene = scene
        state.activeVersion = version
    },
    setScene(state, { scene, activeScene}) {
        Vue.set(state.project.scenes, activeScene, scene)
    },
    setSceneName(state, { scene, name }) {
        state.project.scenes[scene].name = name
    },
    setSceneGuests(state, { scene, guests }) {
        Vue.set(state.project.scenes[scene], 'guests', guests)
    },
    removeSceneGuest(state, { scene, guestIndex }) {
        const guests = state.project.scenes[scene].guests

        guests.splice(guestIndex, 1)

        Vue.set(state.project.scenes[scene], 'guests', guests)
    },
    setPreview(state, status) {
        state.preview = status
    },
    setPreviewGuest(state, guest) {
        const guests = state.project.scenes[state.activeScene].guests
        Vue.set(guests, state.previewGuestIndex, Object.assign(guests[state.previewGuestIndex], guest))
    },
    setPreviewGuestIndex(state, guestIndex) {
        state.previewGuestIndex = guestIndex
    },
    setActiveInvitationContent(state, content) {
        console.log('state.activeScene', state.activeScene)
        console.log('state.activeVersion', state.activeVersion)
        state.project.scenes[state.activeScene].versions[state.activeVersion].content = content
    },
    newSceneVersion(state, scene) {
        state.project.scenes.push(JSON.parse(JSON.stringify(state.project.scenes[scene])));
    },
    newScene(state, scene) {
        if (! state.project.scenes) {
            state.project.scenes = [];
        }

        state.project.scenes.push(scene);
    },
    removeScene(state, index) {
        state.project.scenes.splice(index, 1);
    },
    setLoading(state, loading = true) {
        state.loading = loading;
    },
    setError(state, error) {
        state.error = error;
    },
    setProject(state, project) {
        Vue.set(state, 'project', project);
    },
    updateProject(state, data) {
        Vue.set(state, 'project', Object.assign({}, state.project, data));
    },
}

export const creator = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}